import { render } from "./ProposalName.vue?vue&type=template&id=781615b6"
import script from "./ProposalName.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalName.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "781615b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('781615b6', __exports__)) {
    api.reload('781615b6', __exports__)
  }
  
  module.hot.accept("./ProposalName.vue?vue&type=template&id=781615b6", () => {
    api.rerender('781615b6', render)
  })

}


export default __exports__